import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { ReactComponent as CheerzLogo } from "../../../icons/cheerz-logo.svg";
import "./style.scss";

interface Props {
  fullPage?: boolean;
  loaded?: boolean;
}

const PageLoader: FunctionComponent<Props> = ({ fullPage, loaded }) => {
  return (
    <div
      className={classNames("PageLoader", {
        "PageLoader--fullPage": fullPage,
        "PageLoader--loaded": loaded,
      })}
    >
      <CheerzLogo />
    </div>
  );
};

export default PageLoader;
